import Swiper, { Scrollbar } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-blog-carousel]',
};

class BlogCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);

      this.render();
    });
  }

  render() {
    // Init the carousel on load.
    this.initCarousels();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousels() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      modules: [Scrollbar],
      slidesPerView: 1.1,
      spaceBetween: 20,
      watchOverflow: true,
      freeMode: true,
      scrollbar: {
        el: '.slider-scrollbar',
        draggable: true,
        hide: false,
        snapOnRelease: false,
        dragSize: 130,
      },
      breakpoints: {
        768: {
          spaceBetween: 30,
          slidesPerView: 3,
        },
      },
    });
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.carousel.update();
    });
  }
}

customElements.define('blog-carousel', BlogCarousel);
